<template>
    <div>
        <h1>Best Tracking</h1>
        <el-row :gutter="20">
            <el-col :span="20" :offset="2">
                <el-card shadow="never" style="padding-bottom:20px;">
                    <el-row>
                        <el-col :span="8" class="text-md-left">
                            <el-input v-model="filters[0].value" placeholder="ค้นหาเลข Tracking" style="width:250px;"></el-input>
                            <el-button type="primary" @click="fetchBestTracking" icon="el-icon-refresh">
                            </el-button>
                        </el-col>
                        <el-col :span="6" class="text-md-left">
                            <el-button type="primary" @click="showUpload">
                                <fa-icon name="file-excel"></fa-icon>&nbsp;Upload Tracking
                            </el-button>
                            <input type="file" ref="uploadTracking" style="display:none;" @change="onUploadTracking">
                        </el-col>
                        <el-col class="text-md-left" :span="10">
                            <p style="margin:0px;font-size:18px;">*Tracking ที่พร้อมใช้งาน : <b style="color:#67C23A;">{{ numAvailable }}</b></p>
                            <p style="margin:0px;font-size:18px;">จำนวน Tracking ที่ถูกใช้ไปเมื่อวาน: : <b style="color:rgb(212, 46, 46);">{{ usedYesterday }}</b></p>
                            <p style="margin:0px;font-size:18px;">จำนวน Tracking ที่ถูกใช้งานไปแล้วใน 7 วัน : <b style="color:#339999;">{{ usedLaterDay }}</b></p>
                        </el-col>
                    </el-row>
                    <el-row>
                        <data-tables
                            :data="trackingList"
                            :filters="filters"
                            class="dataTable"
                            :pagination-props="{ pageSizes: [10, 20, 50, 100] }"
                        >
                            <el-table-column type="index" width="50">
                            </el-table-column>
                            <el-table-column label="เลข Tracking" prop="bestTracking">
                                <div class="text-md-left" slot-scope="scope">
                                      <a v-if="scope.row.orderId !== null" target="_blank" :href="'https://www.best-inc.co.th/track?bills=' +  scope.row.bestTracking">{{ scope.row.bestTracking }}</a>
                                      <div v-else>{{ scope.row.bestTracking }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column label="ID เลขออเดอร์" prop="orderId">
                                <div class="text-md-left" slot-scope="scope">
                                      <a v-if="scope.row.orderId !== null" href="#" @click="handleOrderNumberDetail(scope.row.orderId)">{{ scope.row.orderId }}</a>
                                    <div v-else>-</div>
                                </div>
                            </el-table-column>
                            <el-table-column label="วันที่ใช้งานล่าสุด" prop="usedAt">
                                <div v-if="scope.row.usedAt" slot-scope="scope">{{ scope.row.usedAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss') }}</div>
                                <div v-else>-</div>
                            </el-table-column>
                        </data-tables>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import xlsx from 'xlsx'

export default {
    name: 'BestTrackingManage',
    data () {
        return {
            trackingList: [],
            filters: [
                { prop: 'bestTracking', value: '' }
            ],
            numAvailable: 0,
            usedYesterday: 0,
            usedLaterDay: 0
        }
    },
    created () {
        this.fetchBestTracking()
    },
    methods: {
        showUpload () {
            this.$refs.uploadTracking.click()
        },
        onUploadTracking (e) {
            console.log(e)
            this.$loading()
            let files = e.target.files
            let f = files[0]
            this.uploadFile = files[0]
            let parts = f.name.split('.')
            let ext = parts[parts.length - 1]
            if (ext !== 'xlsx') {
                this.$swal({
                    title: 'ผิดพลาด !',
                    text: 'ไฟล์ที่ต้องการอัพโหลดไม่ถูกต้อง',
                    type: 'error'
                })
                return
            }
            let reader = new FileReader()
            reader.onload = async (e) => {
                let data = e.target.result
                let workbook = xlsx.read(data, { type: 'binary' })
                let wsname = workbook.SheetNames[0]
                let ws = workbook.Sheets[wsname]
                let readData = xlsx.utils.sheet_to_json(ws, { header: 1 })
                let dataArray = {
                    arr_tracking: []
                }
                let dataWithoutKey = readData.slice(1, readData.length)
                dataWithoutKey.forEach((row, rowIdx) => {
                    if (String(row) !== '') {
                        dataArray.arr_tracking.push(String(row))
                    }
                })
                console.log(dataArray)
                console.log(dataArray.arr_tracking.length)
                this.createMutiBestTracking(dataArray)
            }
            reader.readAsBinaryString(f)
        },
        async fetchBestTracking () {
            const dataloading = this.$loading({
                target: '.dataTable'
            })
            try {
                let dateNormal = new Date()
                let dateFormat = `${dateNormal.getFullYear()}-${String((dateNormal.getMonth() + 1)).padStart(2, '0')}-${String(dateNormal.getDate()).padStart(2, '0')} 00:00:00`
                console.log(dateFormat)
                const dateNow = this.$dayjs(dateFormat)
                let res = await fgApi.courier.getBestTrackingAll()
                this.trackingList = res.data
                this.numAvailable = this.trackingList.filter(tracking => tracking.orderId === null).length
                let trackingUsed = this.trackingList.filter(tracking => tracking.usedAt !== null)
                this.usedYesterday = trackingUsed.filter(tracking => dateNow.diff(this.$dayjs(tracking.usedAt), 'day', true) < 1 && dateNow.diff(this.$dayjs(tracking.usedAt), 'day', true) > 0 && tracking.orderId !== null).length
                this.usedLaterDay = trackingUsed.filter(tracking => dateNow.diff(this.$dayjs(tracking.usedAt), 'day', true) <= 7 && dateNow.diff(this.$dayjs(tracking.usedAt), 'day', true) > 0 && tracking.orderId !== null).length
            } catch (error) {
                console.log(error)
                this.$notify.error({
                    title: 'Error',
                    message: 'Get best tracking error'
                })
            }
            dataloading.close()
        },
        async createMutiBestTracking (dataTracking) {
            try {
                let res = await fgApi.courier.createBestTracking(dataTracking)
                if (res.success) {
                    this.$message({
                        type: 'success',
                        message: 'Upload completed'
                    })
                    this.fetchBestTracking()
                } else {
                    this.$message({
                        type: 'error',
                        message: 'มีเลข Tracking นี้ ' + res.duplicationTracking.toString() + ' แล้วในระบบ'
                    })
                }
                this.$refs.uploadTracking.value = ''
            } catch (error) {
                console.log(error)
                this.$notify.error({
                    title: 'Error',
                    message: 'Get courier sorting error'
                })
            }
            this.$loading().close()
        },
        handleOrderNumberDetail (orderNumber) {
            let route = this.$router.resolve({
                path: `/oms/logOrder/LogOrderDetail`,
                query: { orderId: orderNumber }
            })
            window.open(route.href, '_blank') // New tab
        }
    }
}
</script>
